import { render, staticRenderFns } from "./AddBins.vue?vue&type=template&id=6cd4cc4f"
import script from "./AddBins.vue?vue&type=script&lang=js"
export * from "./AddBins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports